<template>
  <a v-if="url" 
    :href="url" 
    class="button"
    :class="[buttonSize, buttonStyle, withIcon, onlyIcon]">
      <slot name="content" />
  </a>
  <button v-else 
    type="button"
    class="button"
    :class="[buttonSize, buttonStyle, withIcon, onlyIcon]">
    <slot name="content" />
  </button>
</template>

<script>
import SvgIcon from "vue-svgicon"
  export default {
    name: "IcaButton",
    components: {
      SvgIcon
    },
    props: {
      url: {
        type: String,
        default: ""
      },
      size: {
        type: Number,
        default: 40,
        validator: value => [20, 24, 32, 40, 48, 64].includes(value)
      },
      hasIcon: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: ""
      },
      iconOnly: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      buttonSize () {
        return `button--${this.size}`
      },
      buttonStyle () {
        return `button--${this.type}`
      },
      withIcon () {
        return (this.hasIcon && !this.iconOnly) &&  'button--text-icon'
      },
      onlyIcon () {
        return this.iconOnly && 'button--icon'
      }
    }
  }
</script>